
export const selectNotification = state => state.getIn(['notification', 'messages']).last();
